import { clientPath, lpRequest } from '../../../../core/utils/lp-backend';
import { getUser } from './get-user';

/** `POST /client/:cid/users/:id/regions {region_id}`. */
export const grantRegionAccess = async (user_id: string, region_id: string): Promise<any> => {
  await lpRequest('POST', clientPath(`/users/${user_id}/regions`), { body: { region_id } });

  return getUser(user_id);
};
